import React, { useState } from 'react';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import DatasetSection from './components/DatasetSection';
import InsightsSection from './components/InsightsSection';
import SoNowWhatSection from './components/SoNowWhatSection';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <IntroSection />
      <DatasetSection />
      <InsightsSection />
      <SoNowWhatSection />
    </div>
  );
}

export default App;
